// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UxO3","right":"Footer_right__eeraL","buttons":"Footer_buttons__3507a"};